import { action } from 'sky-engine/api/index'

import { DELIVERY_NETWORK_MNG } from '@/api/apiModules'

export function getPorjectNetworkDetail(data) {
  return action(DELIVERY_NETWORK_MNG, 'detail', data)
}

export function saveOrUpdateNetwork(data) {
  return action(DELIVERY_NETWORK_MNG, 'saveOrUpdate', data)
}
